"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UserQuestion: function() {
        return UserQuestion;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const UserQuestion = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3ZM7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6ZM4.06189 21C4.55399 17.0537 7.92038 14 12 14C12.9596 14 13.8776 14.1685 14.7274 14.4767C15.2467 14.665 15.8202 14.3967 16.0084 13.8775C16.1967 13.3583 15.9284 12.7848 15.4092 12.5965C14.344 12.2102 13.1954 12 12 12C6.47715 12 2 16.4772 2 22C2 22.5523 2.44772 23 3 23H16C16.5523 23 17 22.5523 17 22C17 21.4477 16.5523 21 16 21H4.06189ZM19.9673 16C19.5027 16 19.1098 16.3177 18.9987 16.7493C18.861 17.2841 18.3159 17.6061 17.781 17.4684C17.2462 17.3308 16.9242 16.7856 17.0618 16.2507C17.3948 14.957 18.568 14 19.9673 14C21.6241 14 22.9673 15.3431 22.9673 17C22.9673 17.9314 22.5128 18.5493 22.0367 19.0087C21.8439 19.1949 21.6243 19.3769 21.4269 19.5405C21.3978 19.5646 21.3691 19.5883 21.3412 19.6116C21.1107 19.8033 20.8902 19.9913 20.6744 20.2071C20.2839 20.5976 19.6507 20.5976 19.2602 20.2071C18.8697 19.8166 18.8697 19.1834 19.2602 18.7929C19.5443 18.5087 19.8238 18.2723 20.0622 18.074C20.0937 18.0478 20.1242 18.0225 20.1537 17.998C20.3582 17.8282 20.5134 17.6994 20.6478 17.5697C20.9218 17.3053 20.9673 17.1732 20.9673 17C20.9673 16.4477 20.5195 16 19.9673 16ZM18.9668 22C18.9668 21.4477 19.4145 21 19.9668 21H19.9768C20.5291 21 20.9768 21.4477 20.9768 22C20.9768 22.5523 20.5291 23 19.9768 23H19.9668C19.4145 23 18.9668 22.5523 18.9668 22Z",
        fill: "currentColor"
    })
}), "UserQuestion");
const _default = UserQuestion;
